import React, { useEffect, useMemo, useState } from 'react';
import './HomepageStyle.css';
import HomepageTable from './HomepageTable/HomepageTable';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  fetchEventsBySport,
  fetchInplayEvents,
  getExchangeEvents,
  getInplayEvents,
  setEventType,
} from '../../store';
import GamesContainer from '../../components/GamesContainer/GamesContainer';
import HomepageProvidersLobby from '../../components/HomepageProvidersLobby/HomepageProvidersLobby';
import Footer from '../../components/Footer/Footer';
import { GameMenu } from '../../components/GameMenu/GameMenu';
import SVLS_API from '../../svls-api';
import {
  filterCrashGames,
  filterEzugiGames,
  filterMac88Games,
  filterRoyalGamingLobby,
  filterRoyalGamingVirtuals,
  sample,
} from './HomepageGameFilters';
import { DcGameNew } from '../../models/dc/DcGame';
import HomepageTableMob from './HomepageTable/HomepageTableMob';
import { checkForDomainConfig } from '../../util/domainConfigUtils';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { useDomainConfigHook } from '../../hooks/domainConfigHook';
import Categorygames from '../../components/GamesContainer/Categorygames';
import Sportscontainer from '../../components/GamesContainer/Sportscontainer';
import CopyrightV2 from '../../components/Copyright/CopyrightV2';
import {
  SportIconMap,
  SportIdByNameMap,
  SPToBFIdMap,
} from '../../util/stringUtil';
import { Button } from '@material-ui/core';
import { EventDTO } from '../../models/common/EventDTO';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { connectToWS, disconnectToWS, subscribeWsForEventOdds, unsubscribeAllWsforEvents } from '../../webSocket/webSocket';
type StoreProps = {
  langData: any;
  notificationUpdated: Number;
  events: any;
  topicUrls: any;
  betFairWSConnected: boolean;
  fetchEventsBySport: (sportId: string, events: EventDTO[]) => void;
  selectedEventType: SelectedObj;
  setEventType: (event: SelectedObj) => void;
};
const HomepageV2: React.FC<StoreProps> = ({
  langData,
  events,
  fetchEventsBySport,
  selectedEventType,
  setEventType,
  topicUrls,
  betFairWSConnected
}) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const { loggedIn } = useSelector((state: RootState) => state.auth);
  const [games, setGames] = useState(sample);
  const { showCasinoComponents, showSportsComponents } = useDomainConfigHook();

  const crashGames = useMemo(() => filterCrashGames(games), [games]);
  const mac88Gaming = useMemo(() => filterMac88Games(games), [games]);
  const royalGaming = useMemo(() => filterRoyalGamingLobby(games), [games]);
  const Ezugi = useMemo(() => filterEzugiGames(games), [games]);
  const royalGamingVirtuals = useMemo(
    () => filterRoyalGamingVirtuals(games),
    [games]
  );
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');
  const [wsChannels, setWsChannels] = useState<string[]>([]);

  const sports = [
    {
      name: 'Cricket',
      img: SportIconMap[SportIdByNameMap['cricket']],
      sportId: SportIdByNameMap['cricket'],
    },
    {
      name: 'Football',
      img: SportIconMap[SportIdByNameMap['football']],
      sportId: SportIdByNameMap['football'],
    },
    {
      name: 'Tennis',
      img: SportIconMap[SportIdByNameMap['tennis']],
      sportId: SportIdByNameMap['tennis'],
    },
  ];

  const [favouriteCasinoGames, setFavouriteCasinoGames] =
    useState<DcGameNew[]>();

  const [showNotificationModal, setShowNotificationModal] =
    useState<boolean>(false);

  const fetchNotifications = async () => {
    const response = await SVLS_API.get('/catalog/v2/notifications/', {
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
      },
      params: {
        type: 'ACTIVE',
      },
    });
    // setNotifications(response.data.filter((n) => n.active));
    setNotifications(response.data);
  };

  useEffect(() => {
    if (loggedIn) {
      fetchNotifications();
    }
  }, [loggedIn]);

  // console.log('games', games);

  const dispatch = useDispatch();
  const allEvents = useSelector(
    (state: RootState) => state.exchangeSports.events
  );
  const contentConfig = useSelector(
    (state: RootState) => state.common.contentConfig
  );

  useEffect(() => {
    if (!selectedEventType?.id) {
      setEventType({
        id: sports[0].sportId,
        name: sports[0].name,
        slug: '',
      });
      fetchEventsBySport(sports[0].sportId, events);
    } else {
      fetchEventsBySport(
        SPToBFIdMap[selectedEventType?.id]
          ? SPToBFIdMap[selectedEventType?.id]
          : selectedEventType?.id,
        events
      );
    }
  }, [selectedEventType]);

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  useEffect(() => {
    unsubscribeAllWsforEvents();
    setWsChannels([]);
  }, [selectedEventType]);

  useEffect(() => {
      if (topicUrls?.matchOddsBaseUrl) {
        if (betFairWSConnected) {
          disconnectToWS();
        }
        const baseUrlsPayload = {
          matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
          bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
          premiumBaseUrl: topicUrls?.premiumBaseUrl,
        };
        connectToWS(baseUrlsPayload);
  
        return () => {
          if (betFairWSConnected) {
            disconnectToWS();
          }
        };
      }
    }, [loggedIn, topicUrls]);

  useEffect(() => {
    if (topicUrls?.matchOddsTopic) {
        if (events) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        let subs = [...wsChannels];
        for (let event of events) {
          if (
            event.status === 'IN_PLAY' &&
            !wsChannels.includes(event.eventId)
          ) {
            subs.push(event.eventId);
            subscribeWsForEventOdds(
              topicUrls?.matchOddsTopic,
              event.sportId,
              event.competitionId,
              event.eventId,
              event.matchOdds?.marketId
            );
          }
        }
        setWsChannels(subs);
      }
    }
  }, [betFairWSConnected, selectedEventType, loggedIn]);

  const getFavouriteGames = async () => {
    let response = await SVLS_API.get(
      `/catalog/v2/categories/indian-casino/games/favourites`,
      {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      }
    );

    if (response.status === 200) {
      setFavouriteCasinoGames(response.data);
    }
  };

  const getDcGames = async () => {
    let response;
    if (loggedIn) {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games/', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: '*',
        },
      });
    } else {
      response = await SVLS_API.get('/catalog/v2/indian-casino/games/', {
        params: {
          providerId: '*',
        },
      });
    }
    // setGames(response.data);
    // setProviderList(
    //   response.data
    //     .map((g) => g.subProviderName)
    //     .filter(function (elem, index, self) {
    //       return index === self.indexOf(elem);
    //     })
    // );
  };

  useEffect(() => {
    dispatch(fetchInplayEvents());
    getDcGames();
    getFavouriteGames();
  }, []);

  return (
    <div className="gradient-background">
      {/* <GameMenu /> */}
      <div className="homepage-inplay-table">
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.casino,
          showSportsComponents,
          showCasinoComponents
        ) ? (
            <Categorygames
              title={langData?.['trending_games']}
              gameList={crashGames}
            />
        ) : null}
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.sports,
          showSportsComponents,
          showCasinoComponents
        ) ? (
          <>
            <div className="sports-select-col">
              {sports.map((sport) => (
                <Button
                  onClick={(e) =>
                    setEventType({
                      id: sport.sportId,
                      name: sport.name,
                      slug: '',
                    })
                  }
                  key={sport.sportId}
                  className={
                    selectedEventType?.name.toLowerCase() ===
                    sport.name.toLowerCase()
                      ? 'sport-item'
                      : 'sport-items'
                  }
                >
                  <img
                    src={sport.img}
                    alt={sport.name}
                    className="sport-icon"
                  />
                  <span>{langData?.[sport.name.toLowerCase()]}</span>
                </Button>
              ))}
            </div>
            <div className="web-view">
              <HomepageTable event={events} selectedSport={selectedEventType} />
            </div>

            <div className="mob-view">
              <HomepageTableMob
                event={events}
                selectedSport={selectedEventType}
              />
            </div>
          </>
        ) : null}
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.casino,
          showSportsComponents,
          showCasinoComponents
        ) ? (
          <GamesContainer
            title={langData?.['favourites']}
            gameList={favouriteCasinoGames}
          />
        ) : null}
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.casino,
          showSportsComponents,
          showCasinoComponents
        ) ? (
          <>
            <GamesContainer
              title={langData?.['mac_lobby']}
              gameList={mac88Gaming}
              url={'/casino?provider=Mac88%20Gaming'}
            />
            <GamesContainer
              title={langData?.['royal_gaming_lobby']}
              gameList={royalGaming}
              url={'/casino?provider=Royal%20Gaming'}
            />
          </>
        ) : null}

        {/* <div className="promotion-card-ctn">
          <div className="promotion-card">
            <HomepagePromotionCard
              promotionImgSrc={earnAndPlayImg}
              promotionText={langData?.['play_more_earn_more']}
            />
          </div>
          <div className="promotion-card">
            <HomepagePromotionCard
              promotionImgSrc={playMoreImg}
              promotionText={langData?.['play_more_earn_more']}
            />
          </div>
        </div> */}
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.casino,
          showSportsComponents,
          showCasinoComponents
        ) ? (
          <>
            <GamesContainer
              title={langData?.['live_casino']}
              gameList={Ezugi}
              url={'/casino'}
            />
            <GamesContainer
              title={langData?.['royal_gaming_virtuals']}
              gameList={royalGamingVirtuals}
              url={'/casino?provider=Royal%20Gaming%20Virtual'}
            />

            <HomepageProvidersLobby />
            {/* <GamesContainer title="Top Games" gameList={games} /> */}
          </>
        ) : null}
        {checkForDomainConfig(
          CONFIG_PERMISSIONS.sports,
          showSportsComponents,
          showCasinoComponents
        ) ? (
          <Sportscontainer title={langData?.['sports_book']} gameList={[]} />
        ) : null}
        <CopyrightV2 loggedIn={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  return {
    loggedIn: state.auth.loggedIn,
    langData: state.common.langData,
    selectedEventType: eventType,
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
    events: getExchangeEvents(state.exchangeSports.events, eventType?.id),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventsBySport: (sportId: string, events: EventDTO[]) =>
      dispatch(fetchEventsBySport(sportId, events)),
    setEventType: (eType: SelectedObj) => dispatch(setEventType(eType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomepageV2);
